import { Tooltip as MuiTooltip, styled } from '@material-ui/core';
import { Theme } from '@material-ui/core';

const Tooltip = styled(MuiTooltip)<Theme>(({ theme }) => ({
  '& .tooltip': {
    backgroundColor: theme.palette.grey['A700'],
    fontFamily: theme.config.secondaryFontFamily,
    fontSize: theme.typography.bodyMd.fontSize,
  },
  '& .arrow': {
    color: theme.palette.grey['A700'],
  },
  '& .tooltip.MuiTooltip-tooltipPlacementLeft .arrow': {
    transformOrigin: 'left center',
  },
}));

export default Tooltip;
